/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PossibleEventLastmile } from './possibleEvent';


/**
 * Request for a single action with a cargo (pickup / drop) or work at a location.
 */
export interface DemandLastmile { 
    /**
     * Location key, unique ID.
     */
    key: string;
    /**
     * The demand types are loading (`PICKUP`), unloading (`DROP`), work at the location (`WORK`).
     */
    demand_type: DemandLastmileDemandTypeEnum;
    /**
     * Cargo keys list for `PICKUP`, one cargo key for  `DROP`, empty key for `WORK`.
     */
    target_cargos?: Set<string>;
    /**
     * Precedence within a trip, 0 - the precedence is not taken into account.
     */
    precedence_in_trip?: number;
    /**
     * Precedence within an order, 0 - the precedence is not taken into account.
     */
    precedence_in_order?: number;
    /**
     * List of possible time windows and location keys to fulfil an order.
     */
    possible_events: Array<PossibleEventLastmile>;
    /**
     * Attributes, used to add service information that does not affect planning.
     */
    attributes?: Set<string>;
}
export enum DemandLastmileDemandTypeEnum {
    PICKUP = 'PICKUP',
    DROP = 'DROP',
    WORK = 'WORK'
};



